const actions = {
  GET_CATEGORY_DETAILS: "GET_CATEGORY_DETAILS",
  GET_CATEGORY_DETAILS_SUCCESS: "GET_CATEGORY_DETAILS_SUCCESS",
  GET_CATEGORY_DETAILS_FAILED: "GET_CATEGORY_DETAILS_FAILED",

  getCategoryDetails: (agentId) => ({
    type: actions.GET_CATEGORY_DETAILS,
    payload: { agentId }
  }),

  // ✅ return array directly, not { data }
  getCategoryDetailsSuccess: (data) => ({
    type: actions.GET_CATEGORY_DETAILS_SUCCESS,
    payload: data
  }),

  getCategoryDetailsFailed: (error) => ({
    type: actions.GET_CATEGORY_DETAILS_FAILED,
    payload: error
  })
};

export default actions;
